var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 90,
    viewBox: "0 0 76 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 76,
    height: 16,
    rx: 2,
    transform: "rotate(45 16 14)",
    fill: "#EC2B26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 16,
    rx: 2,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 60 14)",
    fill: "#EC2B26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.ee573ce8472b178b8155bd0c38495af0.svg";
export { ForwardRef as ReactComponent };